import classnames from 'classnames'
import Cookies from './Cookies'

import styles from './styles.module.scss'

const CookiePolicyPage = () => (
    <>
        <div className={styles.topImage} />
        <div className={styles.cookiePolicyPage}>
            <h3 className="text-center mb-5">
                <T>cookie.page.title</T>
            </h3>
            <div className={classnames('mb-5', styles.cookieText)}>
                <T>cookie.page.content</T>
            </div>
            <h3>
                <T>cookie.page.manage.title</T>
            </h3>
            <Cookies showSettings />
        </div>
    </>
)

export default CookiePolicyPage
